import cAsg from './cAsg.vue';

export default {
  install(Vue) {
    Vue.component('cAsg', cAsg);
  },
};